import state from "@/store/modules/my-schedule/state";
import actions from "@/store/modules/my-schedule/actions";
import mutations from "@/store/modules/my-schedule/mutations";
import getters from "@/store/modules/my-schedule/getters";

export default {
  state,
  actions,
  mutations,
  getters
}